import React from 'react';
import LocationSelector from '../../componentes/comuns/LocationSelector';

const Login = () => {
    return (
        <>
            <LocationSelector/>
        </>
    );
}

export default Login;